import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';

import FormInput from '../form-input/form-input.component';
import CustomButton from '../custom-button/custom-button.component';

import { redeemVoucher } from '../../app.service';

// 

import './voucher-results.styles.scss';


const VoucherResults = (props) => {
    console.log("props",props)
    const AddressForm  = (props) => {
        const [values, setValues] = useState({
            firstname: '',
            lastname: '',
            phone: '',
            streetAddress: '',
            suburb: '',
            province:'',
            postCode:'',
        });

        const [province, setProvince] = useState('');
        const [touched, setTouched] = useState({});
        const [saving, setSaving] = useState(false);

        const handleCategoryChange = (province) => {
           setProvince(province.target.value);
           console.log("6666",province.target.value);
        //    setTouched({
        //     ...touched,
        //     [province]: true,
        //     });
       }
        const options = [
            {
                value:'', label:'Select a Province'
            },
            {
            value:'Gauteng', label:'Gauteng'
            },
            {
            value:'Limpopo', label:'Limpopo'
            },
            {
            value:'Eastern Cape ', label:'Eastern Cape '
            },
            {
            value:'North West', label:'North West'
            }, 
            {
            value:'Free State', label:'Free State'
            },
            {
            value:'Western Cape', label:'Western Cape'
            }, 
            {
            value:'Northern Cape', label:'Northern Cape'
            },
            {
            value:'KZN', label:'KZN'
            },
            {
            value:'Mpumalanga', label:'Mpumalanga'
            }
          ];
          const defaultOption = options[0];

        const [updateStatus, setUpdateStatus] = useState();
        const validate = /^\d{10}$/;
        function isValid(p) {
            var phoneRe = /^[2-9]\d{2}[2-9]\d{2}\d{4}$/;
            var digits = p.replace(/\D/g, "");
            return phoneRe.test(digits);
          }

        const handleSubmit = async (e) => {

          

            e.preventDefault();
            const { firstname, lastname, phone, streetAddress, suburb, postCode } = values;
            const voucherDelivery = {firstname, lastname, phone, streetAddress, suburb, province, postCode, voucher};

            console.log("voucher", voucherDelivery);
            // if(touched.phone === true && voucherDelivery.phone !== 10){
            //     console.log("Wrong pattern" , voucherDelivery.phone.length, touched.phone);
            // }
            // else
           if(province === ''){
                console.log("Province is empty province")
            }
            else if(touched.phone === true && voucherDelivery.phone !== 10){
                setSaving(true);
                await axios.post(`${redeemVoucher()}`, voucherDelivery)
                .then(res => {
                   if(res.data.result === 'success'){
                       setUpdateStatus("Congratulations! Your voucher has been successfully Redeemed. We will be in contact shortly to arrange delivery.")
                   }else{
                       setUpdateStatus("Failed to Redeem")
                   }
                }) 
                .catch((error) => {
                    console.log("error", error)
                }) 
            }
        
        
        };


        const handleChange = name => e => {
            console.log("touched", touched)
            setSaving(false);
           
            
            setValues({ ...values, [name]: e.target.value });
            setTouched({
                ...touched,
                [name]: true,
                });
            console.log("name", e.target.value)
       
        };

    const voucher = props;

    //console.log("voucher", voucher)
   
    if(typeof voucher.voucherRes === 'object' && voucher.voucherRes.length > 0){
        console.log("voucher2", updateStatus)
        
        {
            return typeof updateStatus !== 'undefined' ? <h3 className='statusMessage'>{updateStatus}</h3> 
            : 
            (
                <div className='voucherFormResult'>
                <h2 className='title'>Please supply your delivery address below to redeem the voucher</h2>
                {/* 
                <span>Sign up with your email and password</span> */}
                <form className='sign-up-form' onSubmit={handleSubmit}>
                    <FormInput
                        type='name'
                        name='firstname'
                        value={values.firstname}
                        onChange={handleChange('firstname')}
                        label='First Name'
                        required
                    />
                  <FormInput
                        type='name'
                        name='lastname'
                        value={values.lastname}
                        onChange={handleChange('lastname')}
                        label='Last Name'
                        required
                    />
                      <FormInput
                        type='phone'
                        name='phone'
                        value={values.phone}
                        onChange={handleChange('phone')}
                        label='Enter your 10 digit Phone No.'
                        pattern="^-?[0-9]\d*\.?\d*$"
                        required
                    />
                     <p className='validate'>{touched.phone === true && values.phone.length != 10 ? 'Enter your 10 digit Phone No.' : ''}</p>
                     <FormInput
                        type='address'
                        name='streetaddress'
                        value={values.streetAddress}
                        onChange={handleChange('streetAddress')}
                        label='Street Address'
                        required
                    />
    
                    <FormInput
                        type='name'
                        name='suburb'
                        value={values.suburb}
                        onChange={handleChange('suburb')}
                        label='Suburb'
                        required
                    />
                    <p className='validate'>{province === '' ? 'Please select a province*' : ''}</p>
                    <select className='dropdown' value={province} onChange={handleCategoryChange}>
                    {options.map((option) => (
                    <option value={option.value}>{option.label}</option>
                    ))}
                </select>
                
                    {/* <FormInput
                        type='name'
                        name='province'
                        value={values.province}
                        onChange={handleChange('province')}
                        label='Province'
                        required
                    /> */}
                    {/* <Dropdown options={options} onChange={event => setProvince(event.target.value)} value={province} placeholder="Select an option" /> */}
                    {/* <select name="category" value={province} onChange={event => handleCategoryChange(event.target.value)}>
                        <option id="0" >Personal</option>
                        <option id="1" >Work</option>
                    </select> */}
                    <FormInput
                        type='name'
                        name='postCode'
                        value={values.postCode}
                        onChange={handleChange('postCode')}
                        label='Post Code'
                        pattern="^-?[0-9]\d*\.?\d*$"
                        required
                    />  
                    {
                    saving === true ? <h2> Redeeming Voucher...</h2> : <button type='submit'> SUBMIT </button>
                    }   
                    
                    <br/>
                   
                </form>
                <br/><br/><br/><br/><br/>
              
                </div>
                
            )    
        }
        
        
    }else {
        return (<h3>{voucher.voucherRes}</h3>)
    }


  
    }

    return(
        <div>
            {AddressForm(props)}
        </div>
    )


}

    



export default VoucherResults;
